import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import { Flex } from '../UI/Flex/Flex';
interface ModalShowVariableProps {
    variableName: string;
    variableValue: string;
}
export const ModalShowVariable = observer((props: ModalShowVariableProps) => {
    const rawHtmlWithDefault = marked.parse(
        props.variableValue as string,
        { async: false }
    );

    let sanitizedHtml = DOMPurify.sanitize(rawHtmlWithDefault as string);

    return (
        <Flex fillCell={true} direction="column">
            <ScrollPanel>
                <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }}></div>
            </ScrollPanel>
        </Flex>
    );
});
